import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './labeler.module.scss';

export interface ILabelerItem {
  label: string;
}

export interface ILabelerProps extends ILabelerItem {
  children: ReactNode;
  className?: string;
}

const Labeler = ({ label, children, className = '' }: ILabelerProps) => {
  /* ClassNames */

  const containerClasses = cn(styles.labeler, className);

  return (
    <div className={containerClasses}>
      <p className={styles.labeler__label}>{label}</p>
      {children}
    </div>
  );
};

export default Labeler;
